"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
var palettes_1 = require("../styles/palettes");
var styles_2 = require("../styles");
var styles = function (_a) {
    var spacing = _a.spacing;
    return styles_1.createStyles({
        container: {
            display: 'flex',
            height: '100%',
        },
        column: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
        },
        allTechnologies: function (_a) {
            var isMobile = _a.isMobile;
            return ({
                flex: 1.25,
                marginLeft: isMobile ? 0 : spacing(2),
                '@media screen and (max-width: 500px)': {
                    width: '100%',
                },
            });
        },
        divider: {
            backgroundColor: palettes_1.dark[100],
            margin: spacing(0, 2, 0, 4),
        },
        technologiesList: __assign({ overflowY: 'auto', overflowX: 'hidden' }, styles_2.withCustomVerticalScrollbar()),
        selectedTechnologies: {
            flex: 1,
        },
    });
};
exports.styles = styles;
